import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { firstValueFrom } from 'rxjs';
import { notifyAndTrackError } from '../../../../common/error';
import { warningMsg } from '../../../../common/messages';
import { LockInitialWidthDirective } from '../../../../directives/lock-initial-width.directive';
import { AppInsightsService } from '../../../../services/app-insights.service';
import { IPermits } from '../../../../services/insecta';
import { PermitsAdminService } from '../../../../services/insecta/admin/permitslist-admin.service';

@Component({
  selector: 'app-poc-insect-item',
  standalone: true,
  imports: [SelectModule, CommonModule, FormsModule, InputNumberModule, FloatLabelModule, CardModule, LockInitialWidthDirective],
  templateUrl: './poc-insect-item.component.html'
})
export class PocInsectItemComponent {
  private readonly permitService = inject(PermitsAdminService);
  private readonly msgService = inject(MessageService);
  private readonly appInsights = inject(AppInsightsService);

  @ViewChild('insectVariantSelect', { read: ElementRef }) insectVariantSelect!: ElementRef;
  @ViewChild('growthStageSelect', { read: ElementRef }) growthStageSelect!: ElementRef;
  @ViewChild('permitSelect', { read: ElementRef }) permitSelect!: ElementRef;

  @Input() editingInstance: boolean = false;
  @Input() editingMode!: string;
  @Input() distinctInsects: any[] = [];
  @Input() distinctGrowthStages: any[] = [];
  @Input() distinctInsectVariants: any[] = [];
  @Input() idMaps: any[] = [];
  @Output() insectItemChangeEvent = new EventEmitter<any>();

  permits: IPermits[] = [];
  insectItem = {
    quantity: null,
    insectVariantId: null,
    insectGrowthStageId: null,
    catalogInsectGrowthStageId: null,
    catalogInsectVariantId: null,
    permitId: null
  };
  growthStageDisabled: boolean = true;
  insectGrowthStages: any[] = [];

  ngOnInit(): void {
    this.getPermits();
  }

  private getPermits(): void {
    firstValueFrom(this.permitService.getPermitsAll())
      .then((result) => {
        this.permits = result.filter((x) => x.isActive);
      })
      .catch((err) => {
        warningMsg(this.msgService, 'Error in fetching permits');
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'PocInsectItemComponent', action: 'LoadPermits' });
      });
  }

  mapGrowthStages(event: any) {
    console.log('Mapping growth stages for variant:', event.value);

    this.insectItem.catalogInsectGrowthStageId = null;
    this.insectItem.insectGrowthStageId = null;
    const insectVariantId = event.value;
    const insectVariant = this.distinctInsectVariants.find((insect: any) => insect.insectVariantId === insectVariantId);
    const maps = this.idMaps.filter((x: any) => x.catalogInsectId === insectVariant.catalogInsectId);

    this.insectGrowthStages = this.distinctGrowthStages.filter((growthStage: any) =>
      maps.some((map: any) => map.insectGrowthStageId === growthStage.insectGrowthStageId)
    );
    this.insectGrowthStages = this.insectGrowthStages.sort((a: any, b: any) => a.name.localeCompare(b.name));

    // const insect = this.catalogInformation.find((item: any) => item.CatalogInsectId === insectVariant.catalogInsectId);
    // this.insectGrowthStages = insect.GrowthStages.filter((x: any) => x.CatalogInsectId === insectVariant.catalogInsectId);
    // this.insectGrowthStages = this.insectGrowthStages.sort((a: any, b: any) => a.GrowthStageName.localeCompare(b.GrowthStageName));
    this.growthStageDisabled = false;
    // afterRender(() => this.emitInsectItem());
    Promise.resolve().then(() => this.emitInsectItem());
  }

  // emitInsectItem() {}
  emitInsectItem(): any {
    // if (this.insectItem.insectVariantId) {
    //   const variant = this.insectsVariantsConcatenated.find((x) => x.value === this.insectItem.insectVariantId);
    //   this.insectItem.catalogInsectVariantId = variant ? variant.catalogInsectVariantId : null;
    // }

    // if (this.insectItem.insectGrowthStageId) {
    //   const growthStage = this.insectGrowthStages.find((x) => x.InsectGrowthStageId === this.insectItem.insectGrowthStageId);
    //   this.insectItem.catalogInsectGrowthStageId = growthStage ? growthStage.CatalogInsectGrowthStageId : null;
    // }

    this.insectItemChangeEvent.emit(this.insectItem);
  }
}
